module.exports = __webpack_public_path__ + "fonts/deposit-guide-1.f2496246s.png";